"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1483],{

/***/ 96933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84441);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var SideViewModal = function(param) {
    var children = param.children, isOpen = param.isOpen, setIsOpen = param.setIsOpen, _background = param.background, background = _background === void 0 ? "#FFF" : _background, _isMenu = param.isMenu, isMenu = _isMenu === void 0 ? false : _isMenu;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .AnimatePresence */ .M, {
                children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                            className: "position-fixed vh-100 top-0 end-0 side-view-modal-cont",
                            initial: {
                                x: "100%"
                            },
                            animate: {
                                x: 0
                            },
                            exit: {
                                x: "100%"
                            },
                            transition: {
                                type: "easy-in-out",
                                bounce: 0,
                                duration: 0.5
                            },
                            children: children
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                            initial: {
                                opacity: 0
                            },
                            animate: {
                                opacity: 1
                            },
                            exit: {
                                opacity: 0
                            },
                            transition: {
                                type: "spring",
                                bounce: 0,
                                duration: 0.2
                            },
                            onClick: function() {
                                return setIsOpen(function(isOpen) {
                                    return !isOpen;
                                });
                            },
                            style: {
                                background: "rgba(0, 0, 0, 0.75)",
                                zIndex: "3001"
                            },
                            className: "px-5 position-fixed vh-100 vw-100 d-flex align-items-center justify-content-center top-0 start-0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n                .side-view-modal-cont {\n                    background: ".concat(background, "; \n                    z-index: 3002; \n                    width: 50%;\n                    max-width: 700px;\n                    min-width: 320px;\n                    overflow-y: auto;\n                }\n\n                @media (max-width: 1200px) {\n                    .side-view-modal-cont {\n                        width: 60%;\n                        z-index: 3002; \n                        max-width: ").concat(isMenu ? "320px" : "600px", ";\n                        min-width: 320px;\n                        overflow-y: auto;\n                    }\n                }\n\n                @media (max-width: 768px) {\n                    .side-view-modal-cont {\n                        width: 80%;\n                        z-index: 3002; \n                        max-width: ").concat(isMenu ? "320px" : "600px", ";\n                        min-width: 320px;\n                        overflow-y: auto;\n                    }\n                }\n            ")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SideViewModal);


/***/ }),

/***/ 11483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home_HomeNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Loading.js
var Loading = __webpack_require__(67292);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
// EXTERNAL MODULE: ./src/contexts/AuthContext.js
var AuthContext = __webpack_require__(61951);
// EXTERNAL MODULE: ./src/helpers/utils.js
var utils = __webpack_require__(24644);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/aws-amplify/node_modules/@aws-amplify/auth/lib-esm/Auth.js + 31 modules
var Auth = __webpack_require__(95707);
// EXTERNAL MODULE: ./src/common/Functions.js
var Functions = __webpack_require__(82817);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 105 modules
var motion = __webpack_require__(71471);
;// CONCATENATED MODULE: ./src/components/Buttons/MenuToggle.js





var Path = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.path */.E.path, (0,_object_spread/* default */.Z)({
        fill: "#572148",
        strokeWidth: "3",
        stroke: "#572148",
        strokeLinecap: "round"
    }, props));
};
var MenuToggle = function(param) {
    var toggle = param.toggle, isOpen = param.isOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: toggle,
        style: {
            zIndex: "10000",
            border: "none",
            background: "transparent"
        },
        className: "jsx-b6c719fc72c1a9fa",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "23",
                height: "23",
                viewBox: "0 0 23 23",
                className: "jsx-b6c719fc72c1a9fa",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                        animate: isOpen ? "open" : "closed",
                        variants: {
                            closed: {
                                d: "M 2 2.5 L 20 2.5"
                            },
                            open: {
                                d: "M 3 16.5 L 17 2.5"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                        d: "M 2 9.423 L 20 9.423",
                        animate: isOpen ? "open" : "closed",
                        variants: {
                            closed: {
                                opacity: 1
                            },
                            open: {
                                opacity: 0
                            }
                        },
                        transition: {
                            duration: 0.1
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                        animate: isOpen ? "open" : "closed",
                        variants: {
                            closed: {
                                d: "M 2 16.346 L 20 16.346"
                            },
                            open: {
                                d: "M 3 2.5 L 17 16.346"
                            }
                        }
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "b6c719fc72c1a9fa",
                children: "button.jsx-b6c719fc72c1a9fa:focus{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;box-shadow:none!important}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-cycle.js + 1 modules
var use_cycle = __webpack_require__(64777);
// EXTERNAL MODULE: ./src/pages/DedicatedEventPage/GeneralComponents/SideViewModal.js
var SideViewModal = __webpack_require__(96933);
// EXTERNAL MODULE: ./public/img/profile-dropdown/Enter.svg
var Enter = __webpack_require__(88279);
var Enter_default = /*#__PURE__*/__webpack_require__.n(Enter);
;// CONCATENATED MODULE: ./src/pages/Home/HomeNav.js






















// import Dashboard from '../../../public/img/profile-dropdown/Dashboard Layout.svg'
// import User from '../../../public/img/profile-dropdown/User.svg'

//import ResourcesMenu from "./ResourcesMenu";
var SwitchApplications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4893).then(__webpack_require__.bind(__webpack_require__, 34893));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34893)
            ];
        }
    }
});
// import ProfileCard from "../../components/NavigationBar/ProfileCard.js"
var ProfileCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7510).then(__webpack_require__.bind(__webpack_require__, 27510));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27510)
            ];
        }
    }
});
var ResourcesMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8343), __webpack_require__.e(6555)]).then(__webpack_require__.bind(__webpack_require__, 6555));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6555)
            ];
        }
    }
});
var HomeNav = function() {
    var authContext = (0,react.useContext)(AuthContext/* default */.Z);
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_cycle/* useCycle */.n)(false, true), 2), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(null), isDropdownVisible = ref1[0], setDropdownVisible = ref1[1];
    var handleLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var message, cookies;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    message = "Logged Out Successfully";
                    (0,utils/* successToaster */.zh)(message);
                    authContext.setAuth({
                        attributes: {}
                    }, false);
                    cookies = js_cookie_default().get();
                    Object.keys(cookies).map(function(key) {
                        if (key.includes("CognitoIdentityServiceProvider")) js_cookie_default().remove(key);
                    });
                    (0,Functions/* removeCognitoFromLocalStorage */.q2)();
                    js_cookie_default().remove("authToken", {
                        sameSite: "strict"
                    });
                    Auth/* Auth.signOut */.g.signOut();
                // router.replace('/', undefined, { shallow: false })
                } catch (err) {
                    console.error(err.message);
                }
                return [
                    2
                ];
            });
        });
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMouseEnter = function(comp) {
        setDropdownVisible(comp);
    };
    var handleMouseLeave = function() {
        setDropdownVisible(null);
    };
    var handleMediaQueryChange = function(matches) {
        smallerScreen = matches;
    // matches will be true or false based on the value for the media query
    };
    var smallerScreen = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    }, undefined, handleMediaQueryChange);
    var hideProfile = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: style_default().dynamic([
                    [
                        "306562da58d17a73",
                        [
                            isOpen && "body {\n          overflow: hidden;\n        }"
                        ]
                    ]
                ]) + " " + "d-flex app-header px-3 px-lg-4 px-lg-5 py-3 justify-content-between align-items-center align-items-lg-flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            zIndex: 100
                        },
                        className: style_default().dynamic([
                            [
                                "306562da58d17a73",
                                [
                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                ]
                            ]
                        ]) + " " + "ps-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/img/logo.svg",
                                className: "nav-logo d-inline-block link-text",
                                alt: "Konfhub",
                                width: 170,
                                height: 45,
                                style: {
                                    cursor: "pointer"
                                }
                            })
                        })
                    }),
                    !smallerScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    zIndex: 100
                                },
                                className: style_default().dynamic([
                                    [
                                        "306562da58d17a73",
                                        [
                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                        ]
                                    ]
                                ]) + " " + " d-flex align-items-center justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "306562da58d17a73",
                                            [
                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                            ]
                                        ]
                                    ]) + " " + "app-menu d-none d-lg-flex d-xl-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/events",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "app-menu-item mx-lg-3 mx-md-1 py-2",
                                                children: "Events"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/features",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "app-menu-item mx-lg-3 mx-md-1 py-2",
                                                children: "Features"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/usecases",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "app-menu-item mx-lg-3 mx-md-1 py-2",
                                                children: "Use Cases"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            onMouseEnter: function() {
                                                return handleMouseEnter("resources");
                                            },
                                            onMouseLeave: handleMouseLeave,
                                            className: style_default().dynamic([
                                                [
                                                    "306562da58d17a73",
                                                    [
                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                    ]
                                                ]
                                            ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1 resources-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "",
                                                    children: [
                                                        "Resources",
                                                        isDropdownVisible === "resources" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "fas fa-angle-up px-2"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "fas fa-angle-down px-2"
                                                        })
                                                    ]
                                                }),
                                                isDropdownVisible === "resources" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResourcesMenu, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/pricing",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "app-menu-item mx-lg-3 mx-md-1 py-2",
                                                children: "Pricing"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    zIndex: 100
                                },
                                className: style_default().dynamic([
                                    [
                                        "306562da58d17a73",
                                        [
                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                        ]
                                    ]
                                ]) + " " + "d-flex align-items-center justify-content-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "306562da58d17a73",
                                            [
                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                            ]
                                        ]
                                    ]) + " " + "app-menu d-none d-md-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config/* hostEventUrl */.K4, "/create/event"),
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "text-decoration-none mx-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "btn btn-header btn-styles ",
                                                    children: "Host Event"
                                                })
                                            }),
                                            authContext.signedIn === null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + " d-flex justify-content-center align-items-center  ms-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "me-5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading["default"], {
                                                        className: "m-auto",
                                                        color: "#fb5850"
                                                    })
                                                ]
                                            }) : authContext.signedIn === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + " d-flex justify-content-center align-items-center align-items-lg-baseline ms-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "me-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchApplications, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCard, {
                                                        onLogout: function(e) {
                                                            return handleLogout(e);
                                                        },
                                                        hideProfile: hideProfile
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "d-flex header-menu-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config/* loginUrl */.x4, "/login?redirect=Konfhub"),
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "text-decoration-none ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "btn btn-login ",
                                                        children: "Log In"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    smallerScreen && authContext.signedIn != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                zIndex: 100
                            },
                            className: style_default().dynamic([
                                [
                                    "306562da58d17a73",
                                    [
                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                    ]
                                ]
                            ]) + " " + "d-flex align-items-center justify-content-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: style_default().dynamic([
                                    [
                                        "306562da58d17a73",
                                        [
                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                        ]
                                    ]
                                ]) + " " + "app-menu d-flex nav-mobile-menu",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: authContext.signedIn == true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "306562da58d17a73",
                                                    [
                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                    ]
                                                ]
                                            ]) + " " + " d-flex justify-content-center align-items-center ms-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: style_default().dynamic([
                                                    [
                                                        "306562da58d17a73",
                                                        [
                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                        ]
                                                    ]
                                                ]) + " " + "me-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchApplications, {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuToggle, {
                                        toggle: function() {
                                            return setIsOpen(function(prevState) {
                                                return !prevState;
                                            });
                                        },
                                        isOpen: isOpen
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideViewModal/* default */.Z, {
                                        isOpen: isOpen,
                                        setIsOpen: setIsOpen,
                                        isMenu: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "306562da58d17a73",
                                                    [
                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                    ]
                                                ]
                                            ]) + " " + "mt-5 px-3",
                                            children: [
                                                authContext.signedIn === true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "d-flex px-1 py-2 text-left switchEvent-pad pt-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + " pr-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: authContext.user.attributes["custom:profilePicture"],
                                                                alt: "Propfile P",
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "306562da58d17a73",
                                                                        [
                                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "profile-dropDown-img profile-container"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + " details-container ms-2 pl-0 pr-0 mt-auto mb-auto",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    style: {
                                                                        color: "#572148"
                                                                    },
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "h5 profile-email mb-0",
                                                                    children: authContext === null || authContext === void 0 ? void 0 : authContext.user.attributes.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    style: {
                                                                        color: "#808080"
                                                                    },
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "profile-sub-text mb-0",
                                                                    children: authContext === null || authContext === void 0 ? void 0 : authContext.user.attributes.email
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config/* hostEventUrl */.K4, "/create/event"),
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "text-decoration-none w-100 d-block py-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "btn btn-header btn-styles w-100 justify-content-center",
                                                        children: "Host Event"
                                                    })
                                                }),
                                                authContext.signedIn === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "d-flex header-menu-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(config/* loginUrl */.x4, "/login?redirect=Konfhub"),
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "text-decoration-none w-100 ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "btn btn-login w-100 justify-content-center",
                                                            children: "Log In"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + "mt-2 nav-mob"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]) + " " + " d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "306562da58d17a73",
                                                                [
                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                ]
                                                            ]
                                                        ]) + " " + "app-menu",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/events",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1",
                                                                    children: "Events"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/features",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1",
                                                                    children: "Features"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/usecases",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1",
                                                                    children: "Use Cases"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/pricing",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1",
                                                                    children: "Pricing"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                onMouseEnter: function() {
                                                                    return handleMouseEnter("resources");
                                                                },
                                                                onMouseLeave: handleMouseLeave,
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "306562da58d17a73",
                                                                        [
                                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "app-menu-item mx-lg-3 mx-md-1 pt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "306562da58d17a73",
                                                                                [
                                                                                    isOpen && "body {\n          overflow: hidden;\n        }"
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: [
                                                                            "Resources",
                                                                            isDropdownVisible === "resources" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "306562da58d17a73",
                                                                                        [
                                                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                                                        ]
                                                                                    ]
                                                                                ]) + " " + "fas fa-angle-up px-2"
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "306562da58d17a73",
                                                                                        [
                                                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                                                        ]
                                                                                    ]
                                                                                ]) + " " + "fas fa-angle-down px-2"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isDropdownVisible === "resources" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResourcesMenu, {})
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                authContext.signedIn === true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        fontFamily: "Nunito",
                                                        fontWeight: "700",
                                                        letterSpacing: "0px"
                                                    },
                                                    className: style_default().dynamic([
                                                        [
                                                            "306562da58d17a73",
                                                            [
                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                            ]
                                                        ]
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "mt-2 nav-mob"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "".concat(config/* hostEventUrl */.K4),
                                                            target: "_blank",
                                                            style: {
                                                                color: "#572148"
                                                            },
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "text-decoration-none d-block pb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "",
                                                                    children: "Dashboard"
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/profile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: "#572148"
                                                                },
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "306562da58d17a73",
                                                                        [
                                                                            isOpen && "body {\n          overflow: hidden;\n        }"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "d-block py-2",
                                                                children: "Manage Profile"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "mt-2 nav-mob"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            style: {
                                                                color: "#572148",
                                                                cursor: "pointer",
                                                                letterSpacing: "0px"
                                                            },
                                                            onClick: function(e) {
                                                                return handleLogout(e);
                                                            },
                                                            className: style_default().dynamic([
                                                                [
                                                                    "306562da58d17a73",
                                                                    [
                                                                        isOpen && "body {\n          overflow: hidden;\n        }"
                                                                    ]
                                                                ]
                                                            ]) + " " + "me-2 py-2",
                                                            children: [
                                                                "Logout ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: (Enter_default()),
                                                                    alt: "logout icon",
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "306562da58d17a73",
                                                                            [
                                                                                isOpen && "body {\n          overflow: hidden;\n        }"
                                                                            ]
                                                                        ]
                                                                    ])
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "306562da58d17a73",
                dynamic: [
                    isOpen && "body {\n          overflow: hidden;\n        }"
                ],
                children: ".resources-margin.__jsx-style-dynamic-selector{margin-top:4px!important}.profile-container.__jsx-style-dynamic-selector{height:44px}".concat(isOpen && "body {\n          overflow: hidden;\n        }", '.__jsx-style-dynamic-selector hr.__jsx-style-dynamic-selector .nav-mob.__jsx-style-dynamic-selector{border:#000;color:#cacaca!important}.header-menu-item.__jsx-style-dynamic-selector{color:#572148;font-size:16px;text-decoration:none}.app-header.__jsx-style-dynamic-selector{background:#f6f9fc;width:100%}.nav-logo.__jsx-style-dynamic-selector{height:45px}.link-text.__jsx-style-dynamic-selector{cursor:pointer}.btn-styles.__jsx-style-dynamic-selector{font-family:Montserrat;font-size:16px;font-weight:600;line-height:20px;height:40px;letter-spacing:0em;text-align:left}.app-menu.__jsx-style-dynamic-selector .app-menu-item.__jsx-style-dynamic-selector{font-family:Nunito;font-size:16px;font-weight:700;line-height:21px;letter-spacing:0em;text-align:left}.header-menu-item.__jsx-style-dynamic-selector{color:#572148;font-size:16px;text-decoration:none}.nav-logo.__jsx-style-dynamic-selector{height:45px!important}.link-text.__jsx-style-dynamic-selector{cursor:pointer}.btn-styles.__jsx-style-dynamic-selector{font-family:Montserrat;font-size:16px;font-weight:600;line-height:20px;height:40px;letter-spacing:0em;text-align:left}.app-menu.__jsx-style-dynamic-selector .app-menu-item.__jsx-style-dynamic-selector{font-family:Nunito;font-size:16px;font-weight:700;line-height:21px;letter-spacing:0em;text-align:left}.app-menu.__jsx-style-dynamic-selector .app-menu-item.__jsx-style-dynamic-selector:hover{text-decoration:underline}.btn-login.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:10px 25px;height:40px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid#fb5850;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;font-family:"Montserrat";font-style:normal;font-weight:600;min-width:100px;font-size:16px;line-height:20px;color:#fb5850}.btn-login.__jsx-style-dynamic-selector:hover{background:#fb5850;color:#572148}.dropdown-menu.show.__jsx-style-dynamic-selector{inset:unset!important}.dropdown-menu.__jsx-style-dynamic-selector>li.__jsx-style-dynamic-selector{margin:0px!important}.app-menu.__jsx-style-dynamic-selector .host-event.__jsx-style-dynamic-selector{font-size:16px;line-height:24px;color:#fb5850;border:2px solid#fb5850;text-decoration:none}.app-menu.__jsx-style-dynamic-selector .user.__jsx-style-dynamic-selector{font-size:20px}.nav-buttons.__jsx-style-dynamic-selector{color:#fff;text-decoration:none;z-index:99}.nav-buttons-active.__jsx-style-dynamic-selector{color:#fb5850}.dropdown-user.__jsx-style-dynamic-selector{margin-top:5px;display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width:991px){.btn-login.__jsx-style-dynamic-selector{padding:10px 22px}}')
            })
        ]
    });
};
/* harmony default export */ var Home_HomeNav = (HomeNav);


/***/ })

}]);